import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/toast';
import { downloadTechnicianWorkbook } from 'api/techniciansApi';
import { downloadBlob } from 'utils/downloadBlob';
import { activeLocale } from 'i18n';

/** F9 — the template (`prefill=false`) or the base export, saved and toasted; never throws. */
export const useWorkbookDownload = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const [preparing, setPreparing] = useState(false);

  const download = async (country: string, prefill: boolean): Promise<void> => {
    setPreparing(true);
    try {
      const { blob, filename } = await downloadTechnicianWorkbook(country, prefill, activeLocale());
      downloadBlob(blob, filename);
      toast.success(t('{{filename}} downloaded', { filename }));
    } catch {
      toast.error(t('The file could not be prepared. Try again.'));
    } finally {
      setPreparing(false);
    }
  };

  return { download, preparing };
};
